/**
 * Global utility functions for common logic across the application.
 */

/**
 * Validates a keyboard event against a specific alphanumeric pattern.
 * Allowed characters: a-z, A-Z, 0-9, +, @, ., _, -
 * @param event The keyboard event to test
 * @returns boolean
 */
export const setRegex = (event: KeyboardEvent): boolean => {
  const regex = /^[a-zA-Z0-9+@._-]+$/g;
  return regex.test(event.key);
};

/**
 * Validates a name keyboard event.
 * Allowed characters: a-z, A-Z, space, dot, hyphen
 * @param event The keyboard event to test
 * @returns boolean
 */
export const setRegexName = (event: KeyboardEvent): boolean => {
  const regex = /^[a-zA-Z .-]+$/g;
  return regex.test(event.key);
};

/**
 * Prevents non-numeric input and allows control keys.
 * @param event The keyboard event to test
 */
export const preventNonNumeric = (event: KeyboardEvent): void => {
  if (
    !/^\d$/.test(event.key) &&
    !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(
      event.key
    )
  ) {
    event.preventDefault();
  }
};
